module.exports = __webpack_public_path__ + "img/banner.1d11a069.png";